/**
 * Centralized API configuration
 * Production: uses https://nextechplm.com (no trailing slash)
 * Local dev:  set REACT_APP_API_URL=http://localhost:5000 in .env
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://nextechplm.com";

export default API_BASE_URL;
